import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { environment } from '../../../environments/environment';
import { ON_DEMAND_LABEL } from '../nav-labels';

@Component({
  selector: 'app-footer',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class FooterComponent {
  readonly currentYear = new Date().getFullYear();
  readonly accessUrls = environment;

  /**
   * Estilo de los enlaces del pie, en un solo lugar.
   *
   * Estaba repetido en cada uno de los doce enlaces: una cadena de ocho clases
   * que había que mantener sincronizada a mano. El padding con margen negativo
   * agranda el área táctil sin mover el ritmo visual.
   */
  /** Navegación principal del pie; en el template era markup repetido. */
  readonly exploreLinks = [
    { path: '/artists', label: 'Artistas' },
    { path: '/worksofart', label: 'Obras' },
    { path: '/events', label: ON_DEMAND_LABEL },
    { path: '/about', label: 'Sobre Art Stgo' },
    { path: '/contact', label: 'Contacto' },
  ];

  readonly linkClass =
    '-mx-2 block rounded px-2 py-2 text-neutral-300 transition-colors duration-200 ' +
    'hover:text-primary focus-visible:outline focus-visible:outline-2 ' +
    'focus-visible:outline-offset-2 focus-visible:outline-primary motion-reduce:transition-none';
}
